import { useState, useEffect } from 'react';
import { Card, Space } from 'antd';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import CategoryDrawer from '../../Common/CategoryDrawer';
import utils from '../../Common/utils';
import { Pagination, Table, Button } from 'antd';
import { PlusOutlined, EditFilled } from '@ant-design/icons';
import { setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import { useSelector, useDispatch } from "react-redux";

const api = new APIClient();


const CategoriesList = (props) => {
  document.title = "Kategorije" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterdata = useSelector((state) => state.Filterdata.data)
  const searchPending = useSelector((state) => state.Filterdata.searchPending)

  const [editedId, setEditedId] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      // Only the normal search box.
      hidden: ['relateds_group', 'intent_type', 'intent_checkboxes_group', 'dt_range'],
      disabled: []
    }))
  }, []);

  const onEdit = (id) => {
    setEditedId(id)
    setOpen(true);
  }

  const loadCategories = () => {
    setLoading(true);
    api.get('/api/categories/', filterdata)
      .then((resp) => setCategoriesData(resp))
      .finally(() => setLoading(false));
  }

  const columns = [
    {title: 'Naziv', dataIndex: 'title'},
    {title: 'Uredi', key: 'edit', render: r => <Button size='small' onClick={ev => onEdit(r.id)}><EditFilled/></Button>}
  ]

  useEffect(() => {
      loadCategories()
  }, [filterdata]);


  return (
    <>
      <CategoryDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedId(null);
        }}
        onDone={() => {
          loadCategories(filterdata);
          setEditedId(null);
          setOpen(false);
        }}
        id={editedId}
      />

      <Breadcrumb parentTitle="Statični podatki" pageTitle="Kategorije" />

      <Card
        title='Kategorije'
        extra={
          <Space>
            <Button
              onClick={ev => {
                setEditedId(null)
                setOpen(true)
              }}
              icon={<PlusOutlined />}
            />
          </Space>
        }
      >
        <Table
            size="small"
            loading={loading || searchPending}
            columns={columns}
            dataSource={categoriesData?.results || []}
            pagination={false}
            rowKey={obj => obj.id}
            rowClassName={(record) => {}}
        />
        <Pagination
            current={filterdata.page}
            onChange={pInx => dispatch(updateFilterData({page: pInx}))}
            showSizeChanger={false}
            {...utils.processPagination(categoriesData?.pagination)}
        />
      </Card>
    </>
  )
}

export default CategoriesList;
